<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：商品管理-商品编辑-高级设置
    -->
  <div class="buy-set-content pl16 pr16" >
    <!--其他设置-->
    <div class="common-form mt50">云仓设置</div>

    <el-form-item label="编码批次：">
      <el-radio-group v-model="form.model.code_product_open">
        <el-radio :label="0">关闭</el-radio>
        <el-radio :label="1">开启</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="开启云仓配送：">
      <el-radio-group v-model="form.model.open_storage">
        <el-radio :label="0">关闭</el-radio>
        <el-radio :label="1">开启</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="强制开启云仓配送：">
      <el-radio-group v-model="form.model.force_open_storage">
        <el-radio :label="0">关闭</el-radio>
        <el-radio :label="1">开启</el-radio>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
  export default {
    data() {
      return  {
      };

    },
    inject: ['form'],
    methods: {}
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/Storage.vue